import axios from 'axios'
import * as localConfig from '../config'
import storage from '../utils/storage'
import { Message } from 'element-ui'

const webUrl = localConfig.baseApiUrl
const apikey = localConfig.apikey

const http = axios.create({
  baseURL: webUrl,
  timeout: 300000,
  headers: {
    'Content-Type': 'application/json;charset=UTF-8'
  }
})

// 请求拦截器
http.interceptors.request.use(
  (config) => {
    const token = storage.getItem('token')
    config.headers['apikey'] = apikey
    if (token && token.access_token) {
      config.headers['Authorization'] = 'Bearer ' + token.access_token
    }
    if (config.method === 'post' || config.method === 'put') {
      config.data = JSON.stringify(config.data)
    }
    return config
  },
  (error) => {
    return Promise.reject(error)
  }
)

// 响应拦截器
http.interceptors.response.use(
  (response) => {
    if (response.data.code == 106) {
      storage.removeItem('token')
      storage.removeItem('userInfo')
      Message.error('登录授权已过期，请重新登录')
    }
    return response
  },
  (error) => {
    if (error.response) {
      if (error.response.status === 500) {
        Message.error('网络请求错误')
      }
      if (error.response.status === 401) {
        storage.clear()
        window.location.href = '/'
      }
    }
    return Promise.reject(error)
  }
)

export default http



